import { Statistic } from 'antd';

type FormatNumberOptions = {
  precision?: number;
  defaultValue?: string | JSX.Element;
  fontSize?: string;
};

export const formatNumber = (
  value: number | string | null | undefined,
  options: FormatNumberOptions = {}
): JSX.Element => {
  const { precision = 0, defaultValue = '-', fontSize = '14px' } = options;

  if (value == null || value === '' || Number.isNaN(Number(value))) {
    return typeof defaultValue === 'string'
      ? <div style={{ textAlign: 'right', width: '100%' }}>{defaultValue}</div>
      : defaultValue;
  }

  const numValue = Number(value);
  const rounded = precision > 0 ? numValue : Math.round(numValue);

  return (
    <Statistic
      value={rounded}
      precision={precision}
      groupSeparator=" "
      valueStyle={{ fontSize: fontSize, textAlign: 'right' }}
      formatter={(v) =>
        typeof v !== 'number'
          ? String(v)
          : v.toLocaleString('ru-RU', {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
          })
      }
    />
  );
};

export const renderNumberCell = (
  value: any,
  precision: number = 0,
  options: FormatNumberOptions = {}
): JSX.Element => {
  return formatNumber(value, { precision, ...options });
};
